import StateModule from './types'

export default {
  sessions: {}!,
  isTest: false,
  showTestEvaluation: false
} as StateModule
